import React from 'react';
import { Link } from 'react-router-dom';
import LiveBetaBanner from '../components/common/LiveBetaBanner';
import AuthForm from '../components/auth/AuthForm';
import useAuthForm from '../hooks/useAuthForm';

const SignupPage = ({ sessionRef, setAuthResolving, authError }) => {
  const form = useAuthForm({
    mode: 'register',
    sessionRef,
    setAuthResolving,
  });

  const displayForm = authError
    ? { ...form, error: form.error || authError }
    : form;

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <LiveBetaBanner />
      <div className="flex flex-1 flex-col items-center justify-center p-4">
        <p className="mb-4 text-sm text-text-muted">
          <Link to="/" className="text-primary hover:text-primary-dark underline-offset-4 hover:underline">
            Back to Shuttlr
          </Link>
        </p>
        <AuthForm mode="register" form={displayForm} switchTo="/login" />
      </div>
    </div>
  );
};

export default SignupPage;
